import React from 'react';

export default class ServicesStatusOverview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pending: this.props.services.filter(service =>
                ['pending', 'incomplete', 'rejected'].includes(service.registrationStatus.toLowerCase())
            ),
            approved: this.props.services.filter(service => service.registrationStatus.toLowerCase() === 'approved'),
        };
    }

    renderList = (services, messageKey) => {
        return (
            <div className={'card'}>
                <div className="update__msg">
                    <p>{window.VULOG_TRANSLATE(messageKey)}</p>
                </div>
                <ul className={'check-list services'}>
                    {services.map(service => {
                        return (
                            <li key={service.id}>
                                <span className={'check-list__label'}>{service.name}</span>
                                <span className={`check-list__status`}>
                                    {service.registrationStatus === 'approved' ? (
                                        <svg version="1.1" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                                        </svg>
                                    ) : (
                                        <svg version="1.1" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M16.9,7.1C18.2,8.3 19,10.1 19,12C19,13.9 18.1,15.6 16.9,16.9C15.7,18.2 13.9,19 12,19C10.1,19 8.4,18.2 7.1,16.9L12,12V5C13.9,5 15.7,5.8 16.9,7.1Z" />
                                        </svg>
                                    )}
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    };
    render() {
        return (
            <div className="update__container services">
                {this.state.approved.length > 0 &&
                    this.renderList(
                        this.state.approved,
                        this.props.paymentPending ? 'SERVICES_APPROVED_PENDING_PAYMENT' : 'SERVICES_APPROVED'
                    )}
                {this.state.pending.length > 0 && this.renderList(this.state.pending, 'SERVICE_REVIEW_NEEDED')}
            </div>
        );
    }
}
